/*
 * PDP offer block — snippets/cdt-pdp-offer.liquid
 *
 * Two jobs, both progressive enhancement: if either source is missing the
 * corresponding line simply stays hidden, which is why both start [hidden]
 * rather than rendering a placeholder.
 *
 *  1. "N% dintre clienți recomandă produsul", computed from the Judge.me
 *     histogram (4★ + 5★ over the total). The average rating ALONE cannot give
 *     this number, so there is no fallback that would be honest — no histogram,
 *     no line. The widget loads async and lazily, hence the observer.
 *
 *  2. The rating caption, rewritten from Judge.me's "4.8 (19)" to eMAG's
 *     "4,8 (19 review-uri)" — PDP only, and declining the noun for n === 1.
 *
 *  3. Klarna instalments, fetched from their messaging API (not their 1 MB
 *     SDK) and kept on the SELECTED variant's price.
 */
(function () {
  'use strict';

  /* ---------- 1. social proof ---------- */
  function paintSocial() {
    var out = document.querySelector('[data-cdt-po-social]');
    if (!out || out.dataset.done === '1') return false;

    var rows = document.querySelectorAll('.jdgm-histogram__row[data-rating][data-frequency]');
    if (!rows.length) return false;

    var total = 0, happy = 0;
    for (var i = 0; i < rows.length; i++) {
      var stars = parseInt(rows[i].getAttribute('data-rating'), 10);
      var n = parseInt(rows[i].getAttribute('data-frequency'), 10);
      if (isNaN(stars) || isNaN(n)) continue;
      total += n;
      if (stars >= 4) happy += n;
    }
    /* Under ~10 reviews a percentage is noise dressed up as data. */
    if (total < 10) { out.dataset.done = '1'; return true; }

    var pct = Math.round((happy / total) * 100);
    if (pct < 70) { out.dataset.done = '1'; return true; }   // don't advertise a weak number

    out.textContent = pct + '% dintre clienți recomandă produsul';
    out.hidden = false;
    out.dataset.done = '1';
    return true;
  }

  /* ---------- 2. rating caption ---------- */
  /* Judge.me renders "4.8 (19)" from its own template setting
     `{{ average_rating_1_decimal }} ({{ n }})`. eMAG writes the noun out:
     "4.66 (350 review-uri)".

     Done here in the DOM rather than by patching window.jdgmSettings, for two
     reasons: the setting is global, so it would also rewrite the collection
     tiles (which are meant to stay compact "4.9 (195)"), and a static template
     cannot decline the noun — it would print "1 review-uri". */
  function paintRating() {
    var badge = document.querySelector('.jdgm-preview-badge');
    if (!badge) return false;

    var data = badge.querySelector('.jdgm-prev-badge');
    var out = badge.querySelector('.jdgm-prev-badge__text');
    if (!data || !out) return false;

    var n = parseInt(data.getAttribute('data-number-of-reviews'), 10);
    var avg = parseFloat(data.getAttribute('data-average-rating'));
    if (isNaN(n) || isNaN(avg) || n <= 0) return false;

    var noun = n === 1 ? 'review' : 'review-uri';
    var want = avg.toFixed(1) + ' (' + n + ' ' + noun + ')';

    /* Only write on a real difference — Judge.me re-renders the badge, and an
       unconditional write would bounce off our own MutationObserver forever. */
    if (out.textContent.trim() !== want) out.textContent = want;
    return true;
  }

  function tick() {
    paintSocial();
    paintRating();
  }

  /* ---------- 3. Klarna instalments, fetched without their SDK ----------

     One GET to Klarna's CMA messaging endpoint returns the approved copy for a
     given amount + locale (~1.9 KB), instead of loading their ~1.02 MB Web SDK.
     Every string rendered below is Klarna's own — we compose no credit wording.
     See the snippet comment for why that distinction matters legally. */

  var KLARNA_ENDPOINT = 'https://js.klarna.com/eu/cma/v3/messaging';
  var KLARNA_CLIENT_ID = 'dab300fe-6ab6-5bee-8d35-6ddc978af87a';
  var klarnaCache = {};   /* amount -> html, so flipping between variants is free */
  var klarnaToken = 0;    /* guards a slow response for a variant already replaced */

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function klarnaHtml(data) {
    var nodes = (data && data.content && data.content.nodes) || [];
    var text = null, action = null, badge = null;
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.name === 'TEXT_MAIN') text = n.value;
      else if (n.name === 'ACTION_LEARN_MORE') action = n;  /* parsed, not rendered */
      else if (n.name === 'KLARNA_BADGE') badge = n;
    }
    /* No TEXT_MAIN means the amount sits outside Klarna's financing range.
       That is a real answer, not a failure: render nothing. */
    if (!text) return '';

    var out = '';
    if (badge && badge.url) {
      out += '<img class="cdt-po__klarna-logo" src="' + esc(badge.url) +
             '" alt="' + esc(badge.alt || 'Klarna') + '" loading="lazy" decoding="async">';
    }
    out += '<span class="cdt-po__klarna-text">' + esc(text) + '</span>';
    /* ACTION_LEARN_MORE is deliberately NOT rendered — removed by request.
       Klarna still returns it in the payload; if the terms link is ever wanted
       back, render `action.url` with `action.label` and restore the dialog
       block below (see cdm-v3.3-BACKUP for the previous version). */
    return out;
  }

  function loadKlarna(el, amount) {
    amount = parseInt(amount, 10);
    if (!amount || amount <= 0) { el.innerHTML = ''; return; }
    if (Object.prototype.hasOwnProperty.call(klarnaCache, amount)) {
      el.innerHTML = klarnaCache[amount];
      return;
    }

    var token = ++klarnaToken;
    var url = KLARNA_ENDPOINT +
      '?placement_key=' + encodeURIComponent(el.getAttribute('data-key') || 'credit-promotion-badge') +
      '&locale=' + encodeURIComponent(el.getAttribute('data-locale') || 'ro-RO') +
      '&channel=web' +
      '&client_id=' + encodeURIComponent(KLARNA_CLIENT_ID) +
      '&payment_amount=' + encodeURIComponent(amount) +
      '&message_preference=klarna';

    /* 2026-10-09 (storefront error log): Klarna answered 401 in waves (≈500/day on 22–25.09 and 30.09–02.10,
       10–40/day otherwise) for the same request that normally succeeds — one delayed retry on 401/429/5xx
       recovers those; status 0 (ad blockers) is not retried. */
    var getKlarna = function (retried) {
      return fetch(url, { credentials: 'omit', mode: 'cors' }).then(function (r) {
        if (!r.ok && !retried && (r.status === 401 || r.status === 429 || r.status >= 500)) {
          return new Promise(function (res) { setTimeout(res, 1500); }).then(function () { return getKlarna(true); });
        }
        return r;
      });
    };
    getKlarna(false)
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (data) {
        if (token !== klarnaToken) return;        /* a newer variant already won */
        var html = data ? klarnaHtml(data) : '';
        klarnaCache[amount] = html;
        el.innerHTML = html;
        /* Klarna counts placement impressions from this pixel. Skipping it would
           silently under-report us in their merchant dashboard. */
        if (html && data && data.impression_url) {
          var px = new Image();
          px.src = data.impression_url;
        }
      })
      .catch(function () { /* fails quiet, same contract as before */ });
  }

  function wireKlarna() {
    var el = document.querySelector('[data-cdt-klarna]');
    if (!el) return;

    /* Off the critical path. The badge is worth ~2 KB, never a blocked paint. */
    var first = function () { loadKlarna(el, el.getAttribute('data-purchase-amount')); };
    if (window.requestIdleCallback) window.requestIdleCallback(first, { timeout: 1500 });
    else setTimeout(first, 0);

    /* Same event cdt-gallery.js and the frequently-bought-together block use.
       Not a change listener on [name="id"]: the theme swaps variants through
       its own selector and that input is not always what moves. */
    var vs = document.querySelector('[data-variant-selection]');
    if (!vs) return;

    vs.addEventListener('variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v || !v.price) return;
      if (el.getAttribute('data-purchase-amount') === String(v.price)) return;
      el.setAttribute('data-purchase-amount', String(v.price));
      loadKlarna(el, v.price);
    });
  }

  function start() {
    tick();
    wireKlarna();

    /* Observe for a fixed window rather than stopping at the first success.
       Judge.me paints the badge and then re-paints it (the node starts
       display:none and is revealed later), so disconnecting as soon as both
       jobs reported OK meant our caption was written and then overwritten
       straight back to "4.8 (19)". Both writes are difference-guarded, so
       re-asserting cannot bounce off our own observer. */
    var obs = new MutationObserver(tick);
    obs.observe(document.body, { childList: true, subtree: true });

    /* Belt and braces for renders that mutate nothing we can see. */
    [400, 1200, 3000, 8000].forEach(function (ms) { setTimeout(tick, ms); });

    setTimeout(function () { obs.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
